<template>
  <div class="wraper">
    <el-row class='top'>
      <span>未启用设备</span>
      <div class="export_btn">
        <exporter
          :setting='setting'
          :url='getListUrl'
          :date='date'
          :exportName="exportName"
        ></exporter>
      </div>
    </el-row>
    <deviceSearchBox
      :postParams='postParams'
      @getSearchSelect="searchTable"
    ></deviceSearchBox>
    <el-row>
      <report
        :setting='setting'
        :list='list'
        @callFather='handleSun'
      ></report>
      <el-row class="pages">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 50, 100, 200]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        >
        </el-pagination>
      </el-row>
    </el-row>
  </div>
</template>

<script>
    import Report from '../../components/Report'
    import exporter from '../../components/exporter'
    import deviceSearchBox from '../devices/components/unDeviceSearchBox'

    export default {
        name: 'device',
        components: {
            Report,
            exporter,
            deviceSearchBox
        },
        data() {
            return {
                exportName:'未启用报表',
                getListUrl: 'data/getAssetsManagementList',
                date: [],
                clearDate: false,
                postParams: {
                    areaCompany: '',
                    provinceBranchCompany: ''
                },
                currentPage: 1,
                setting: {
                    isShowSelect: false,
                    isShowIndex: true,
                    tHeader: [{
                        dataItem: 'assetsNum',
                        dataName: '资产编号'
                    }, {
                        dataItem: 'areaCompanyName',
                        dataName: '大区'
                    }, {
                        dataItem: 'provinceBranchCompanyName',
                        dataName: '省区/分公司'
                    }],
                    isShowPlay: false,
                    isShowDelBtn: false,
                    isShowEditBtn: false,
                    isShowInfoBtn: true,
                    infoUrl: '',
                    status: 0
                },
                list: [],
                total: 0,
                pageSize: 10
            }
        },
        mounted() {
            this.getList()
        },
        methods: {
            getList() {
                let url = this.getListUrl;
                let paramsObj = this.postParams;
                let params = {
                    status: 0,
                    pageSize: this.pageSize,
                    pageNum: this.currentPage
                }
                for (let k in paramsObj) {
                    if (paramsObj[k] != '')
                        params[k] = paramsObj[k];
                }
                let _this = this;
                this.$ajax.post(url, params)
                    .then(this.getListSucc)
                    .catch(function (res) {
                        _this.$message.error('哎呀~网络异常了呢');
                    })
            },
            getListSucc(res) {
                if (res.data && res.data.code === 200) {

                    const data = res.data.data;
                    this.list = data.list;
                    this.total = data.total;
                    console.log(this.list)
                } else {
                    let errMsg = '未知错误'
                    if (res.data.msg) {
                        errMsg = res.data.msg;
                    }
                    this.$message.error(errMsg);
                }
            },
            handleSizeChange(val) {
                // console.log('每页 '+val+' 条');
                this.pageSize = val;
                this.currentPage = 1;
                this.getList()
                // console.log(this.pageSize);
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.getList()
            },
            handleSun() {

            },
            searchTable() {
                //console.log(this.postParams)
                this.getList();
            }
        }
    }
</script>
<style scoped>
  .top {
    height: 50px;
  }

  .pages {
    padding-top: 10px;
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/pages/devices/devicesUnStart.vue